export interface Classroom {
    code?: string; // Optional, as it is generated by the backend during creation
    name: string; // Required, with validation
    schoolCode: string; // Required, with validation
    status?: ClassroomStatus; // Optional, defaults to ACTIVE
    createdAt?: string; // Read-only, ISO 8601 formatted string
    updatedAt?: string; // Read-only, ISO 8601 formatted string
}

export enum ClassroomStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    ARCHIVE = 'ARCHIVE'
}
